module.exports = __webpack_public_path__ + "img/logo.039153c9.png";